<template>
  <v-content class="gb owner-reports">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <v-card
              :loading="status === 'loading' || status_action === 'loading'"
              class="fill-width table_theme card-theme custom-container"
          >
            <v-card-title class="title_table medium-font" style="letter-spacing: normal">
              #Invoice
              <v-spacer></v-spacer>
              <div class="drop-down-company">
                <v-select
                    v-model="sent"
                    :items="dataStatus"
                    width="100px"
                    class="company-display ui-label ui-label--b pt-0 mr-4 xs-drop-down custom-select-options select-no-border"
                    color="#29ABE2"
                    placeholder="Filter By"
                    type="text"
                    name="filter_by"
                    :multiple="false"
                >
                  <template v-slot:append>
                    <img
                        :src="require('@/assets/img/dropdown-triangle-blue.png')"
                        style="position: relative;"
                        alt
                        width="11px"
                        height="6px"
                    />
                  </template>
                </v-select>
              </div>

            </v-card-title>
            <v-card-subtitle style="margin-left: 1rem;">
              View documents that were created using #invoice in the app and web chat
            </v-card-subtitle>

            <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredItems"
                :sent="sent"
                color="#717e91"
                :multi-sort="false"
                item-key="id"
                :options.sync="options"
                :sort-desc="true"
                :hide-default-footer="true"
                class="db_table db_table_users no-padding dbt_owner_vendor custom-arrow span-owner-vendors db_table_invoices"
            >
              <template v-slot:item.invoice_number="{ item }">
                <span v-if="item.deleted" style="text-decoration: line-through">{{item.invoice_number}}</span>
                <span v-else>{{item.invoice_number}}</span>
              </template>
              <template v-slot:item.service="{ item }">
                <span v-if="item.deleted" style="text-decoration: line-through">{{item.service}}</span>
                <span v-else>{{item.service}}</span>
              </template>
              <template v-slot:item.description="{ item }">
                <span v-if="item.deleted" style="text-decoration: line-through">{{item.description}}</span>
                <span v-else>{{item.description}}</span>
              </template>
              <template v-slot:item.total="{ item }">
                <span v-if="item.deleted" style="text-decoration: line-through">${{item.total}}</span>
                <span v-else>${{item.total}}</span>

              </template>
              <template v-slot:item.creation_date="{ item }">
                <span v-if="item.deleted"
                      style="text-decoration: line-through">{{ setDateCreated(item.creation_date) }}</span>
                <span v-else>{{ setDateCreated(item.creation_date) }}</span>
              </template>
              <template v-slot:item.sent_by="{ item }">
                                <span v-if="item.deleted" style="text-decoration: line-through">
                                    {{ setSendByName(item) }}
                                    <br>
                                  {{ setSendByPhone(item) }}</span>
                <span v-else>{{ setSendByName(item) }}
                                    <br>
                                  {{ setSendByPhone(item) }}</span>
              </template>
              <template v-slot:item.url_invoice="{ item }">
                <div class="d-flex align-center">
                  <a @click="create_image_from_pdf(item.url_invoice)" class="sub_link_header d-flex align-center mr-6"
                     style="text-decoration: none">
                    <img :src="require('@/assets/view.png')" alt="report print" class="mr-2"/>
                  </a>
                  <a :href="item.url_invoice" class="sub_link_header d-flex align-center mr-4" target="_blank">
                    <img :src="require('@/assets/download.png')" alt="download" class="mr-2"/>
                  </a>
                  <a @click="delete_invoice(item.id)" class="sub_link_header d-flex align-center mr-8"
                     style="text-decoration: none">
                    Delete
                  </a>
                </div>
              </template>
            </v-data-table>
            <div style="width: 100%;">
              <v-divider style="max-width: 1096px;"></v-divider>
            </div>

          </v-card>
        </v-col>
      </v-row>

      <invoice-modal :show="showInvoiceModal" :hide="hideInvoiceModal" :url="url_temp_invoice"/>
      <confirm-message-modal
          :show="showConfirmMessageModal"
          :hide="hideConfirmMessageModal"
          :click="clickConfirmMessageModal"
          :cancel="closeConfirmMessageModal"
      ></confirm-message-modal>


    </v-container>
  </v-content>
</template>

<style scoped lang="scss">
  .modal-content {
    max-width: 530px;
  }

  .custom-select-margin {
    margin-top: -10px;
  }
</style>

<script>
  import invoiceModal from "./modals/invoice";
  import confirmMessageModal from "./modals/confirm-delete";
  import {mapState, mapActions} from "vuex";
  import config from "@/config/constants.js";
  import moment from "moment";

  var pdfjsLib = require('pdfjs-dist-for-node')

  let token = localStorage.getItem("auth_token");

  export default {
    name: "vendorsList",
    mounted() {
      this.$store.dispatch('Users_list/clear_data_invoices');
    },
    created() {
      if (this.$store.getters["Authenticate/isLoggedIn"]) {
        this.get_invoices();

      } else {
        this.$router.push("/owner/sign_up");
      }
    },
    computed: {
      ...mapState({
        status: (state) => state.Users_list.status,
        status_action: (state) => state.Users_list.status_action,
        user: (state) => state.Authenticate.user,
        dataInvoices: (state) => state.Users_list.list_invoices
      }),
      filteredItems() {
        const self = this;
        if (self.sent === "All") {
          self.filter_selected = null;
        }
        if (self.sent === "Sent") {
          self.filter_selected = 'Yes';
        }
        if (self.sent === "Received") {
          self.filter_selected = 'No';
        }
        return self.dataInvoices.filter((i) => {
          return (
            !self.filter_selected || i.sent === self.filter_selected
          );
        });
      }
    },
    components: {
      "invoice-modal": invoiceModal,
      "confirm-message-modal": confirmMessageModal,
    },
    data() {
      return {
        options: {
          itemsPerPage: -1
        },
        selected: [],
        showDeleteModal: false,
        showResendModal: false,
        showInvoiceModal: false,
        showConfirmMessageModal: false,
        valid: false,
        types: [],
        dataStatus: ['All', 'Sent', 'Received'],
        search: "",
        items: [
          "Alabama",
          "Alaska",
          "American Samoa",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "District of Columbia",
          "Federated States of Micronesia",
          "Florida",
          "Georgia",
          "Guam",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Marshall Islands",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Northern Mariana Islands",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Palau",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virgin Island",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming"
        ],
        singleSelect: true,
        rutaExel:
          config.api_url +
          "download_exel?user_role=vendor&token=" + token,
        company_data: null,
        menu: false,
        menu1: false,
        menu2: false,
        date1: "",
        date2: "",
        selectedDate1: "",
        selectecDate2: "",
        dates: "",
        invoice_number: null,
        url_invoice: null,
        total: null,
        description: null,
        service: null,
        creation_date: null,
        url_temp_invoice: null,
        invoice_selected: null,
        sent: null,
        filter_selected: null,
        headers: [
          {text: "Invoice #", value: "invoice_number", width: '15px !important'},
          {text: "Service", value: "service", width: '20px !important'},
          {
            text: "Description",
            align: "start",
            sortable: true,
            value: "description"
          },
          {text: "Total ($)", value: "total", width: '15px !important'},
          {text: "Date/Time", value: "creation_date"},
          {text: "Sent By", value: "sent_by", width: '20px !important'},
          {text: "Actions", sortable: false, align: "left", value: "url_invoice", class: 'actions_invoices'}
        ],
      };
    },
    methods: {
      hideInvoiceModal() {
        this.showInvoiceModal = false;
      },
      hideConfirmMessageModal() {
        this.showConfirmMessageModal = false;
      },
      closeConfirmMessageModal() {
        this.showConfirmMessageModal = false;
      },
      clickConfirmMessageModal() {
        this.showConfirmMessageModal = false;
        const self = this;
        self.$store.dispatch("Users_list/delete_invoice_selected", {
          id: self.invoice_selected
        }).then(response => {
          if (response === "SUCCESS") {
            self.$store.dispatch('Users_list/clear_data_invoices', true);
            self.get_invoices();
          }
        })
      },
      async create_image_from_pdf(url_pdf) {
        this.showInvoiceModal = true;
        this.url_temp_invoice = url_pdf;
        let context;
        await pdfjsLib.getDocument({url: url_pdf}).then(async function (res) {
          let _CANVAS = document.querySelector('#pdf-canvas');
          context = _CANVAS.getContext('2d');
          context.clearRect(0, 0, _CANVAS.width, _CANVAS.height);
          let page = await res.getPage(1);
          let pdf_original_width = page.getViewport(1).width;

          // as the canvas is of a fixed width we need to adjust the scale of the viewport where page is rendered
          let scale_required = _CANVAS.width / pdf_original_width;

          // get viewport to render the page at required scale
          let viewport = page.getViewport(scale_required);
          // set canvas height same as viewport height
          _CANVAS.height = viewport.height;
          let render_context = {
            canvasContext: context,
            viewport: viewport
          };
          await page.render(render_context);
          document.querySelector("#pdf-canvas").style.display = 'block';
          document.querySelector("#page-loader").style.display = 'none';


        });

      },
      async delete_invoice(invoice_id) {
        this.showConfirmMessageModal = true;
        this.invoice_selected = invoice_id;

      },
      setDateCreated(value) {
        return moment(value.seconds * 1000).format('MM/DD/YYYY hh:mm a')
      },
      setSendByName(value) {
        let full_name = '';
        if (value.sent_by !== undefined) {
          full_name = value.sent_by.full_name;
        }

        return full_name;
      },
      setSendByPhone(value) {
        let phone = '';
        if (value.sent_by !== undefined) {
          phone = value.sent_by.phone;
        }

        return phone;
      },
      setter() {
        const self = this;
        self.selected = [];
      },
      resetService(item) {
        item.service = null;
        item.service_other = "";

        this.$store.dispatch("Users_list/switch_service", {
          id: item.id,
          value: this.services[0].value,
        });
      },
      service_changed(item, service) {
        if (service !== "") {
          this.$store.dispatch("Users_list/switch_service", {
            id: item,
            value: service,
          });
        }

      },
      ...mapActions({
        get_invoices: "Users_list/get_invoices",
      }),
      async show_DeleteModal() {
        this.showDeleteModal = true;
      },
      hideDeleteModal() {
        this.showDeleteModal = false;
      },
      show_ResendModal() {
        const self = this;
        self.$store
          .dispatch("Users_list/resend_invite", {
            users: self.selected,
            type: "_vendor"
          })
          .then(() => {
            self.showResendModal = true;
          });
      },
      hideResendModal() {
        this.showResendModal = false;
      },
      get_excel(user_role) {
        const self = this;
        self.$store
          .dispatch("Users_list/download", user_role);
      },
      Last30Days() {
        this.date1 = moment()
          .subtract(30, "days")
          .format("ll");
        this.date2 = moment();
      },
      thisWeek() {
        this.date1 = moment().startOf("isoWeek");

        this.date2 = moment();
      },
      lastWeek() {
        this.date1 = moment()
          .subtract(1, "week")
          .startOf("week");

        this.date2 = moment()
          .subtract(1, "week")
          .endOf("week");
      },
      thisMonth() {
        this.date1 = moment().startOf("month");

        this.date2 = moment().endOf("month");
      },
      lastMonth() {
        this.date1 = moment()
          .subtract(1, "month")
          .startOf("month");

        this.date2 = moment()
          .subtract(1, "month")
          .endOf("month");
      },
      aply() {
        this.selectedDate1 = moment(this.date1).format("ll");
        this.selectecDate2 = moment(this.date2).format("ll");

        this.date1 = "";
        this.date2 = "";
      },
      resetA() {
        this.date1 = "";
      },
      resetB() {
        this.date2 = "";
      }
    }
  };
</script>

<style scoped lang="scss">

  .owner-reports {
    .vue-daterange-picker {
      min-width: 260px;
    }

    .label {
      max-width: 133% !important;
      color: #061d47 !important;
      font-size: 16px !important;
      font-weight: 700 !important;
      line-height: 15.4px !important;
      transform: translateY(-18px) scale(1) !important;
    }

    .mar_table {
      margin: 0 5px !important;
    }

    .aply {
      width: 244px;
      height: 39px;
      border-radius: 29px;
      background-color: #29abe2 !important;
      color: #ffffff;
      font-family: "Roboto-Medium";
      font-size: 14px !important;
      font-weight: 500 !important;
      letter-spacing: 0.88px !important;
      text-transform: capitalize !important;
    }

    .cancel {
      width: 244px;
      height: 39px;
      border-radius: 29px;
      background-color: #a6a6a6 !important;
      color: #3a3a3a;
      font-family: "Roboto-Medium";
      font-size: 14px !important;
      font-weight: 500 !important;
      letter-spacing: 0.88px !important;
      text-transform: capitalize !important;
    }

    .list_menu .v-list-item {
      min-height: 35px !important;
    }

    .list_menu h3 {
      color: #161616;
      font-family: "Roboto-Medium";
      font-size: 13px;
      font-weight: 500;
      letter-spacing: -0.13px;
    }

    .list_menu h5 {
      color: #161616;
      font-family: "Roboto-Medium";
      font-size: 11px;
      font-weight: 500;
      letter-spacing: -0.12px;
      margin-bottom: 0;
    }

    .menu_btn {
      display: block;
      width: 290px;
      margin-right: 20px;
    }

    .table_botonera {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .text_icon {
      color: #717e91;
      font-family: Roboto;
      font-size: 13px;
      font-weight: 400;
      line-height: 15px;
      text-decoration: none;
      display: flex;
      align-items: center;
    }

    .menu_Sub {
      display: flex;
    }

    .drop-down-company {
      display: inline-block;
      width: 110px;
      margin-right: 27px;
      position: relative;
      top: 8px;
      color: #2bace2 !important;
    }

    .custom-container {
      top: 10px;
      max-width: 1222px !important;
      min-height: 636px;
      margin-bottom: 50px;
      padding-bottom: 80px;
    }

    .v-application .text-center {
      position: relative;
      top: 15px;
      left: 4px;
    }

    .text-start {
      position: relative;
      top: 9px;
    }

    .custom-o-sliders {
      position: relative;
      top: 5px;
      left: 20px;
      font-size: 20px;
    }

    .custom-o-white {
      height: 32px !important;
      width: 149px !important;
      top: 8px;
    }

    .table_btn {
      color: #2bace2;
      font-size: 13px;
      font-weight: 400;
      text-transform: capitalize;
      letter-spacing: normal;
    }

    .table_botonera {
      padding: 13px 0px 0px 7px;
      position: relative;
      top: -3px;
      max-width: 1096px;
      margin: 0 auto;
      border-top: solid 1px rgba(0, 0, 0, 0.12);
    }

    .fill-width .mar_table {
      margin: 0 13px;
    }

    .table-f {
      font-size: 13px !important;
    }

    .mi_menu {
      top: 368px !important;
    }
  }
</style>